import timezones from "components/account/timezones";
import { PrettyPrintCondition } from "./conditions-pretty-print";

export function ConditionsFieldSet({
  definition,
  fieldSet,
  condition,
  update,
  path,
  errors,
  editing,
}) {
  const _errors = getError(errors, path);
  const changeHandler = (key) => (e) => {
    update(
      {
        action: "edit",
        key: key,
        value: e.currentTarget.value,
      },
      path
    );
  };
  const changeHandlerBool = (key) => (e) => {
    update(
      {
        action: "edit",
        key: key,
        value: e.currentTarget.value === "true",
      },
      path
    );
  };

  const hideLabels = ["url", "boolean", "domain"].includes(definition.type);
  const hasLabels =
    !hideLabels &&
    Object.values(fieldSet).some((x) => x.label && x.label.length > 0);
  const onlySelects = Object.values(fieldSet).every((x) =>
    isSelect(x, definition)
  );

  return (
    <div className="flex flex-wrap gap-x-1 gap-y-2">
      {editing ? (
        <div className="w-full flex-0 pr-12">
          <p>{definition.title}</p>
          {definition.description && (
            <p className="text-sm opacity-70">{definition.description}</p>
          )}
        </div>
      ) : (
        <div className="w-full flex-0 flex items-center divide-x">
          <p className="text-xs opacity-70 basis-36 flex-shrink-0 text-right pr-2">
            {definition.title}
          </p>
          <p className="pl-2">
            <PrettyPrintCondition
              definition={definition}
              condition={condition}
            />
          </p>
        </div>
      )}
      {editing && (
        <>
          {_errors && (
            <div className="w-full flex-0 text-sm text-red">
              {_errors.join(", ")}
            </div>
          )}
          {Object.entries(fieldSet).map(([key, item]) => (
            <label
              key={key}
              className={`text-sm ${
                onlySelects || !isSelect(item, definition) ? "flex-1" : "flex-0"
              }`}
            >
              {hasLabels && (
                <span className="ml-2">{item.label || <>&nbsp;</>}</span>
              )}
              {isSelect(item, definition) ? (
                <select
                  id={`${path.join("_")}_${item.key}`}
                  className="h-8 block !mt-0 !p-1 bg-white rounded w-full border !border-tabBorder"
                  value={condition.data[key]?.toString()}
                  onChange={
                    item.type === "boolean"
                      ? changeHandlerBool(key)
                      : changeHandler(key)
                  }
                >
                  {item.type === "boolean" ? (
                    <>
                      <option value="false">No</option>
                      <option value="true">Yes</option>
                    </>
                  ) : (
                    (item.type === "timezone"
                      ? timezones
                      : item.type === "param"
                      ? definition.options.map((x) => ({ value: x, label: x }))
                      : Object.entries(item.options).map(([value, label]) => ({
                          value,
                          label,
                        }))
                    ).map(({ value, label }) => (
                      <option key={value} value={value}>
                        {label.replace(
                          "{plural}",
                          definition.plural ?? definition.title
                        )}
                      </option>
                    ))
                  )}
                </select>
              ) : (
                <input
                  id={`${path.join("_")}_${item.key}`}
                  className="h-8 block !mt-0 !px-2 !py-1 bg-white rounded w-full border !border-tabBorder"
                  value={condition.data[key]}
                  type={
                    { date: "date", time: "time", param: "text" }[item.type] ??
                    "text"
                  }
                  onChange={changeHandler(key)}
                  onBlur={changeHandler(key)}
                />
              )}
            </label>
          ))}
        </>
      )}
    </div>
  );
}

function getError(errors, path) {
  let lastNode = errors.errors;
  for (const idx of path) {
    if (!Array.isArray(lastNode)) {
      return false;
    }
    lastNode = lastNode[idx];
  }
  return Array.isArray(lastNode) && lastNode;
}

function isSelect(item, definition) {
  return (
    item.type === "select" ||
    item.type === "timezone" ||
    item.type === "boolean" ||
    (item.type === "param" && definition.options)
  );
}
